import { render, staticRenderFns } from "./competition.vue?vue&type=template&id=55d334f8&scoped=true"
import script from "./competition.vue?vue&type=script&lang=js"
export * from "./competition.vue?vue&type=script&lang=js"
import style0 from "./competition.vue?vue&type=style&index=0&id=55d334f8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d334f8",
  null
  
)

export default component.exports